import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
const NON_DE_LANGS = ['en', 'cs'];
const MissingTranslationsPill = ({ translations, isMissing, }) => {
    const { t } = useTranslation();
    const decider = isMissing ?? ((lang) => !translations[lang]?.available);
    // D-20: never report `de` — it's required, so it cannot be "missing" in any
    // semantically meaningful sense at the row-render layer.
    const missing = NON_DE_LANGS.filter((lang) => decider(lang));
    if (missing.length === 0) {
        return null;
    }
    return (_jsx("span", { className: "faq-missing-pill", title: t('admin.faq.tooltip.missing_translations'), tabIndex: 0, children: t('admin.faq.missing_translations_pill', { langs: missing.join(', ') }) }));
};
export default MissingTranslationsPill;
